export default __webpack_public_path__ + "static/media/JungleSwap-screenshot-mobile.5409e5e5.png";